import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const dictionary = {
  image_carousel_aria_label: {
    'en-GB': `product image`,
    'nl-NL': 'product afbeelding',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
